import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('用户名', 'username', FORM_ITEM.INPUT, { maxlength: '20', clearable: true }),
  createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, { maxlength: '11', clearable: true }),
  createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'USER_STATUS', allOption: true , smartSearch:'true' }), 
]

export const editFormItems = [
  [
    createFormItem('用户名', 'username', FORM_ITEM.INPUT, { maxlength: '20', clearable: true }),
    createFormItem('性别', 'gender', FORM_ITEM.SELECT, { loader: 'USER_GENDER' }),
  ],
  [
    createFormItem('出生日期', 'birthday', FORM_ITEM.DATE_PICKER, {valueFormat: 'YYYY-MM-DD' }),
    createFormItem('邮箱', 'email', FORM_ITEM.INPUT, { maxlength: '50', clearable: true }),
  ],
  [
    createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, { maxlength: '11', clearable: true }),
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'USER_STATUS' }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { maxlength: '200', type: 'textarea', rows: 3, showWordLimit: true }),
  ]
]

export const addFormItems = [
  [
    createFormItem('用户名', 'username', FORM_ITEM.INPUT, { maxlength: '20', clearable: true }),
    createFormItem('性别', 'gender', FORM_ITEM.SELECT, { loader: 'USER_GENDER', default: true, defaultOnNull: true }),
  ],
  [
    createFormItem('出生日期', 'birthday', FORM_ITEM.DATE_PICKER, {valueFormat: 'YYYY-MM-DD' }),
    createFormItem('邮箱', 'email', FORM_ITEM.INPUT, { maxlength: '50', clearable: true }),
  ],
  [
    createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, { maxlength: '11', clearable: true }),
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'USER_STATUS', default: true, defaultOnNull: true }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { maxlength: '200', type: 'textarea', rows: 3, showWordLimit: true }),
  ]
]
export const rules = {
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 4, max: 20, message: '不能少于4个字符', trigger: 'blur' },],
}